import { render, staticRenderFns } from "./user-acknowledgement-popup.html?vue&type=template&id=b3abf416&scoped=true&"
import script from "./user-acknowledgement-popup.js?vue&type=script&lang=js&"
export * from "./user-acknowledgement-popup.js?vue&type=script&lang=js&"
import style0 from "./user-acknowledgement-popup.scss?vue&type=style&index=0&id=b3abf416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3abf416",
  null
  
)

export default component.exports